import { Box, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CustomAutocompleteIndex from 'components/Inputs/AlertKpi/CustomAutocompleteIndex';
import CustomTextFieldIndex from 'components/Inputs/AlertKpi/CustomTextFieldIndex';

const RetentionRuleTab = ({ formData, setFormData, alertTypeOptions }: any) => {
    const theme = useTheme();
    const colors = theme.palette;

    const retainResolvedOptions = [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
    ];

    return (
        <Box sx={{ mt: 3, p: 2, borderRadius: '8px', width: '100%' }}>
            <Typography
                variant="body2"
                sx={{
                    opacity: 0.7,
                    mb: 2,
                    color: `${colors.textLight.main} !important`
                }}
            >
                ⓘ This section is to setup retention rules.
            </Typography>

            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                    <CustomTextFieldIndex
                        label="Retention Duration (days)*"
                        type="number"
                        variant="outlined"
                        size="small"
                        value={formData.retentionRuleConfig?.retentionDuration ?? null}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                            setFormData({ 
                                ...formData, 
                                retentionRuleConfig: { 
                                    ...formData.retentionRuleConfig, 
                                    retentionDuration: e.target.value === '' ? null : Number(e.target.value)
                                }
                            })
                        }
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <CustomAutocompleteIndex
                        id="retain-resolved-alerts"
                        size="small"
                        options={retainResolvedOptions}
                        getOptionLabel={(option: any) => option.label}
                        value={
                            retainResolvedOptions.find(
                                opt => opt.value === formData.retentionRuleConfig?.retainResolvedAlerts
                            ) || null
                        }
                        onChange={(option: any) =>
                            setFormData({
                                ...formData,
                                retentionRuleConfig: {
                                    ...formData.retentionRuleConfig,
                                    retainResolvedAlerts: option ? option.value : null
                                }
                            })
                        }
                        renderInputProps={{
                            label: "Retain Resolved Alerts*",
                            variant: "outlined",
                            fullWidth: true
                        }}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <CustomAutocompleteIndex
                        id="retention-alert-type"
                        size="small"
                        options={alertTypeOptions}
                        getOptionLabel={(option: any) => option.label}
                        value={
                            alertTypeOptions.find(
                                (opt: any) => opt.value === formData.retentionRuleConfig?.alertType
                            ) || null
                        }
                        onChange={(option: any) =>
                            setFormData({ 
                                ...formData, 
                                retentionRuleConfig: { 
                                    ...formData.retentionRuleConfig, 
                                    alertType: option ? option.value : '' 
                                } 
                            })
                        }
                        renderInputProps={{
                            label: "Retention Based on Alert Type*",
                            variant: "outlined",
                            fullWidth: true
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};
export default RetentionRuleTab;